import React from "react";
import { Separator } from "../ui/separator";
import LakehouseLogo from "../../assets/LakehouseLogo.svg";

export default function Footer({ texts }) {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-950 border-t border-gray-800 relative z-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src={LakehouseLogo} 
                alt="Lakehouse Logo" 
                className="w-14 h-14 object-contain"
              />
              <span className="text-xl font-bold bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
                Lakehouse Technologies
              </span>
            </div>
            <p className="text-gray-400 leading-relaxed max-w-md">
              {texts.desc}
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">{texts.services}</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li className="hover:text-white transition-colors cursor-pointer">AI Development</li>
              <li className="hover:text-white transition-colors cursor-pointer">Software Development</li>
              <li className="hover:text-white transition-colors cursor-pointer">Data Analytics</li>
              <li className="hover:text-white transition-colors cursor-pointer">System Architecture</li>
              <li className="hover:text-white transition-colors cursor-pointer">Automation</li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold mb-4">{texts.company}</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li className="hover:text-white transition-colors cursor-pointer">About Us</li>
              <li className="hover:text-white transition-colors cursor-pointer">Our Team</li>
              <li className="hover:text-white transition-colors cursor-pointer">Careers</li>
              <li className="hover:text-white transition-colors cursor-pointer">Contact</li>
            </ul>
          </div>
        </div>

        <Separator className="bg-gray-800 my-8" />

        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            {texts.copyright.replace('{year}', currentYear)}
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors">{texts.privacy}</a>
            <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors">{texts.terms}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
